import Icon from '@material-ui/icons/Settings';

export default Icon;